<template>
  <div class="project-form-inner">
    <template v-for="(video, index) in videos">
      <div :key="video.video_id">
        <div class="form-row-header">
          <span class="form-row-name">{{ video.video_name }}</span>
          <span class="form-row-per-second">Ad price per second:</span>
          <span>{{ getValuePerSecond(video.price, video.length) }}</span>
        </div>
        <div class="form-row-content">
          <div class="form-field">
            <div class="form-field-label">Name</div>
            <el-input v-model="video.broadcast" />
          </div>
          <div class="form-field">
            <div class="form-field-label">Ad price</div>
            <div class="currency">
              <span class="currency-icon" :style="{ 'left': `${23 - 9 * currencyIcon.length}px` }">{{ currencyIcon }}</span>
              <el-input v-model="video.price" type="number" />
            </div>
          </div>
          <div class="form-field">
            <div class="form-field-label">Ad length</div>
            <el-select
              v-model="video.length"
              placeholder="Select length">
              <el-option
                v-for="item in [1, 5, 10, 15, 30, 45, 60]"
                :key="item"
                :label="`${item} seconds`"
                :value="item" />
            </el-select>
          </div>
        </div>
      </div>
      <div v-if="index !== videos.length - 1" class="divider" :key="video.video_id + 'divider'" />
    </template>
  </div>
</template>

<script>
export default {
  name: "PriceInfo",
  props: {
    currencyIcon: {
      type: String,
      required: true,
    },
    videos: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getValuePerSecond(price, length) {
      if (!price || !length || typeof length === 'string') {
        return 'Not selected';
      }
      return `${this.currencyIcon} ${(price / length).toFixed(2)}`;
    },
  },
}
</script>

<style scoped lang="scss">
.project-form-inner {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.form-row-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}

.form-row-name {
  max-width: 60%;
}

.form-row-per-second {
  opacity: 0.5;
  font-size: 14px;
  margin-left: auto;
}

.form-row-content {
  display: flex;
  gap: 10px;
}

.form-field {
  flex: 1;
}

.form-field-label {
  font-weight: 700;
  padding-bottom: 7px;
  opacity: 0.5;
}

.currency {
  position: relative;

  ::v-deep {
    .el-input__inner {
      padding-left: 28px;
    }
  }
}

.currency-icon {
  position: absolute;
  top: 9px;
  left: 14px;
  z-index: 1;
  font-weight: 700;
}

.divider {
  height: 1px;
  background: var(--border-color);
}
</style>
